import { Box, FileInput, Text } from '@mantine/core';
import { IconFile } from '@tabler/icons-react';
import { useState } from 'react';

import { FileCard, PersistentFile } from '@feature/utils';

interface EvaluationAuthorFileProps {
  onUpload: (file: File) => void;
  file: PersistentFile | null;
  label: string;
  description: string;
  onDownload: () => void;
  isSubmitting: boolean;
  disabled?: boolean;
  accept?: string;
}

const defaultAccept =
  'image/png,image/jpeg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/vnd.rar,application/x-rar-compressed,application/x-gzip,application/x-7z-compressed';

export function EvaluationAuthorFile({
  onUpload,
  onDownload,
  description,
  file,
  label,
  isSubmitting,
  disabled,
  accept,
}: EvaluationAuthorFileProps) {
  const [newUpload, setNewUpload] = useState(false);

  if (file == null || newUpload) {
    return (
      <FileInput
        onChange={newFile => {
          if (newFile != null) onUpload(newFile);
          setNewUpload(false);
        }}
        label={label}
        disabled={isSubmitting || disabled}
        description={description}
        placeholder={label}
        withAsterisk
        flex={1}
        leftSection={<IconFile size="20px" />}
        accept={accept ?? defaultAccept}
      />
    );
  }

  return (
    <Box w="46%">
      <Text
        mb="5px"
        size="sm"
        fw="500"
      >
        {label}
      </Text>
      <FileCard
        file={file}
        disabled={isSubmitting || disabled}
        onRemove={() => setNewUpload(true)}
        onDownload={onDownload}
      />
    </Box>
  );
}
